import { getOrderSetupId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_SETUP_ID = "ORDER_SETUP_ID";

export function useOrderSetupIdQuery(orderSetupId?: number | null) {
	return useQuery({
		queryKey: [ORDER_SETUP_ID, orderSetupId],
		queryFn: processResponse(() => getOrderSetupId(orderSetupId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderSetupId,
	});
}
